import * as React from "react";
import * as PropTypes from "../prop-types";
import { RingSize } from "@spscommerce/ds-shared";
import { SpsProgressRing } from "../progress-ring/SpsProgressRing";
import clsx from "clsx";
export interface WizardStep {
  title: string;
  percentComplete: number;
  active: boolean;
  disabled: boolean;
  callback?: () => void;
}
export interface WizardPhase {
  steps: Array<WizardStep>;
  title: string;
  disabled: boolean;
}

const propsDoc = {
  phases: "WizardPhase[]"
};

const propTypes = {
  ...PropTypes.spsGlobalPropTypes,
  phases: PropTypes.arrayOf<WizardPhase>(PropTypes.any)
};
export type SpsWizardSidebarProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsWizardSidebar(props: SpsWizardSidebarProps) {

  const { phases } = props;

  return (
    <>
      <div className="sps-wizard-sidebar">
        {phases.map((phase, phaseIndex) => {
          const titleClasses = clsx(
            "sps-wizard-sidebar__phase-title",
            phase.disabled && "sps-wizard-sidebar__phase-title--disabled"
          );
          return (
            <div className="sps-wizard-sidebar__phase-wrapper" key={phaseIndex}>
              <div className={titleClasses}>
                {phase.title}
              </div>
              {phase.steps.map((step, stepIndex) => {
                const stepClasses = clsx(
                  "sps-wizard-sidebar__step",
                  step.active && "sps-wizard-sidebar__step--active",
                  step.disabled &&  "sps-wizard-sidebar__step--disabled",
                  !!step.callback && !step.disabled && "sps-wizard-sidebar__step--clickable"
                );
                const stepCallback = !step.disabled ? step.callback : undefined;
                return (
                  <div className={stepClasses} key={stepIndex} onClick={stepCallback}>
                    <div className="sps-wizard-sidebar__step-progress">
                      {step.percentComplete === 100 ? (
                        <div className="sps-wizard-sidebar__step-complete">
                          <i aria-hidden="true"
                            className="sps-icon sps-icon-checkmark"></i>
                        </div>
                      ) : (
                          <SpsProgressRing size={RingSize.SMALL} progress={step.percentComplete} />
                        )}
                    </div>
                    <div className="sps-wizard-sidebar__step-title" role="button">
                      {step.title}
                    </div>


                  </div>);
              })}
            </div>
          );
        })}
      </div>
    </>
  );
}
Object.assign(SpsWizardSidebar, {
  props: propsDoc,
  propTypes,
  displayName: "SpsWizardSidebar"
});
